import { Injectable } from "@angular/core";
import { firstValueFrom, Observable, of } from "rxjs";
import { HttpService } from "./http.service";

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  public companyInfo: any | null
  constructor(private httpService: HttpService) { }

  async getCompanyInfo(id: number | null): Promise<any> {
    if (this.companyInfo) return of(this.companyInfo);
    try {
      this.companyInfo = await firstValueFrom(this.getCompany(id!));
      return this.companyInfo;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  getCompanies(params: any): Observable<any[]> {
    return this.httpService.get("company", { params })
  }

  addOrUpdateCompany(payload: any) {
    return this.httpService.post('company', payload);
  }

  getCompany(id: number): Observable<any> {
    return this.httpService.get(`company/${id}`);
  }

  deleteCompany(id: number) {
    return this.httpService.delete(`company/${id}`);
  }

  updateInvoiceAddress(companyId: number, payload: any) {
    return this.httpService.put(`company/${companyId}/invoice-address`, payload);
  }
}
